/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC } from 'react';
import clsx from 'clsx';
import { FormikProps } from 'formik';
import Checkbox from 'react-custom-checkbox';

import { AUTH_ERRORS } from '../../../../../Constants/ErrorMessages';
import Button from '../../../../Button';
import HelperText from '../../../../FormFields/HelperText';
import Typo from '../../../../Typo';
import { SignUpFormData, TRole } from '../../../../../models/auth/@types';
import { getFieldError } from '../../../../FormFields/Utils';
import styles from './finalConfirmations.module.sass';

export interface FinalConfirmationsProps {
  privacyPolicyKey: string;
  roleConfirmationKey: string;
  formikProps: FormikProps<Partial<SignUpFormData>>;
}

export const withLink = (child: React.ReactNode, link: string, openInSameTab?: boolean) => (
  <Button
    linkToUrl={link}
    isExternalLink
    isBtn={false}
    underline
    openInSameTab={!!openInSameTab}
    classes="has-text-weight-bold"
  >
    {child}
  </Button>
);

const RoleConfirmationLabel = {
  [TRole.STUDENT]: 'Yes, I am a high school student aged thirteen (13) years or older.',
  [TRole.TEACHER]:
    'I am an educator or staff person who is authorized to work with students during or after-school',
  [TRole.MENTOR]: (
    <>I have read and agree to the Mentor’s {withLink('Code of Conduct.', 'code-of-conduct')}</>
  ),
  [TRole.ADMIN]: 'I have read and agree to the admin',
};

const FinalConfirmations: FC<FinalConfirmationsProps> = props => {
  const { privacyPolicyKey, roleConfirmationKey, formikProps } = props;

  const privacyError = !!getFieldError(privacyPolicyKey, formikProps);

  const roleError = !!getFieldError(roleConfirmationKey, formikProps);

  return (
    <div className={styles.confirmationsRoot}>
      {(roleError || privacyError) && (
        <div className={styles.confirmationsErrorContainer}>
          <HelperText error>{AUTH_ERRORS.CONFIRMATIONS_REQUIRED}</HelperText>
        </div>
      )}

      <div className={clsx(styles.checkBoxFieldLabel, styles?.checkBox)}>
        <Checkbox
          icon={<div style={{ backgroundColor: 'green', borderRadius: 5, padding: 5 }} />}
          id="form_field_check_box_check_box_1"
          borderColor={roleError && '#c70000'}
          name={roleConfirmationKey}
          borderRadius="2px"
          borderWidth="1px"
          className={`${styles.checkBoxField} ${roleError && styles.errorShadow}`}
          onChange={(value: boolean) => {
            formikProps.setFieldValue(roleConfirmationKey, value);
          }}
        />
        <label htmlFor="form_field_check_box_check_box_1">
          <Typo classes={`has-text-left is-size-9 ${styles.grayText}`}>
            {RoleConfirmationLabel[formikProps.values.role as Exclude<TRole, TRole.ADMIN>]}
          </Typo>
        </label>
      </div>

      <div className={clsx(styles.checkBoxFieldLabel, styles?.checkBox)}>
        <Checkbox
          icon={<div style={{ backgroundColor: 'green', borderRadius: 5, padding: 5 }} />}
          id="form_field_check_box_check_box_2"
          borderColor={privacyError && '#c70000'}
          name={privacyPolicyKey}
          borderRadius="2px"
          borderWidth="1px"
          className={`${styles.checkBoxField} ${privacyError && styles.errorShadow}`}
          onChange={(value: boolean) => {
            formikProps.setFieldValue(privacyPolicyKey, value);
          }}
        />
        <label htmlFor="form_field_check_box_check_box_2">
          <Typo classes={`has-text-left is-size-9 ${styles.grayText}`}>
            By clicking here I affirm that yes, I have read the{' '}
            {withLink('Terms of Service', 'terms-of-service')} and{' '}
            {withLink('Privacy Policies', 'privacy-policy')} outlined by the KnoPro website and
            agree to all they entail.
          </Typo>
        </label>
      </div>
    </div>
  );
};

export default FinalConfirmations;
